var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6302 17.4687C35.4502 16.9987 39.9802 13.6287 40.0102 8.7887V8.7487C39.9802 3.9087 35.4502 0.5387 30.6302 0.0687004C25.2602 -0.4513 9.33021 2.0987 5.01021 3.7387C4.49021 3.9387 4.15021 4.4387 4.15021 4.9987V12.5387C4.15021 13.0987 4.49021 13.5987 5.01021 13.7987C9.33021 15.4487 25.2702 17.9887 30.6302 17.4687Z",
    fill: "#F0DEDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1502 38.4187C30.4102 41.1387 32.3202 43.6887 35.0502 43.7087H35.0702C37.8002 43.6887 39.7002 41.1387 39.9702 38.4187C40.2602 35.3887 38.8302 26.3987 37.9002 23.9587C37.7902 23.6687 37.5102 23.4687 37.1902 23.4687H32.9302C32.6202 23.4687 32.3302 23.6587 32.2202 23.9587C31.2902 26.3987 29.8602 35.3887 30.1502 38.4187Z",
    fill: "#F0DEDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90019 21.6287C17.2002 13.3287 30.2602 7.5787 33.2002 10.5187C36.1402 13.4587 30.3902 26.5187 22.0902 34.8187C13.7902 43.1187 7.89019 46.4587 2.57019 41.1487C-2.74981 35.8287 0.590191 29.9387 8.90019 21.6287Z",
    fill: "#E1909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f9fc382a698e57c49efb9a7bd4b73192.svg";
export { ForwardRef as ReactComponent };